import { userInitial } from './user';
import type { GlobalContextReducerState } from './types';

export const defaultState: GlobalContextReducerState = {
  user: userInitial
};
